module.exports = __webpack_public_path__ + "img/tatum.cd9f7441.svg";